import './Selector.css'
import ribbons from '../assets/constants/ribbons.js';
import ribbonRack from '../assets/images/ribbonRack.png';
import React from "react"

function RibbonSelector(props) {

    return (
        <div className="">
                    <div className="spoolsOnRackDiv">
                        {ribbons.map((ribbon, index) => (
                            <div key={index}>
                                <img onClick={() => props.setSelectedRibbon(index)} className={ribbon.spoolClass + " ribbonSpoolColor"} src={ribbon.spoolColorSrc} alt={ribbon.alt} />
                                <img onClick={() => props.setSelectedRibbon(index)} className={ribbon.spoolClass} src={ribbon.spoolSrc} alt={ribbon.alt} />
                            </div>
                        ))}
                    </div>
            <img className="ribbonRackImage" src={ribbonRack} alt="a black metal wire rack drawing" />
        </div>
    )
}

export default RibbonSelector;